import React, {Component} from 'react';
import {Container, Row, Card, Col} from 'react-bootstrap';
import './Projects.css';
import Footer from './Footer';
import './Contact.css';
import OsrwNav from './CustomNavbar';
import GibButtons from './GibButtons';


function ContactCard(props) {
    let {appData} = props;
    let imgSrc = appData.isMobile? "https://orzw-resources.s3.eu-central-1.amazonaws.com/615x615/2.jpg" :
        "https://orzw-resources.s3.eu-central-1.amazonaws.com/1230x615/2.jpg";
    return (

        <Card style={{
            flex: 1,
            padding: 0,
            margin: 0,
            marginTop: appData.isMobile ? '0' : '0',
            borderRadius: '0',
            border: 'none',
            minWidth: '100vw',
            maxWidth: '100vw'
        }}>
            <Card.Img variant="top" src={imgSrc}
                      style={{margin: 0, padding: 0, borderRadius: '0', border: 'none'}}/>
            <Card.ImgOverlay style={{
                borderRadius: '0',
                border: 'none',
                marginTop: appData.isMobile? '20.5vh' : '30vh',
                marginLeft: appData.isMobile? '7vw' : '40vw',
            }}>
                <Card.Body>
                    {appData.isMobile ?
                        (<div>
                            <h5 style={{color: 'white', fontWeight: 'bold'}}>OŚRODEK REHABILITACJI ZWIERZĄT CHRONIONYCH</h5>
                            <h6 style={{color: 'white', fontWeight: 'bold'}}>UL. ZAMOYSKIEGO 15</h6>
                            <h6 style={{color: 'white', fontWeight: 'bold'}}>37-700 PRZEMYŚL</h6>
                            <h6 style={{color: 'white', fontWeight: 'bold'}}>osrodek.rehabilitacji@gmail.com</h6>
                            <a href="tel:+166787168"><h6 style={{color: 'white', fontWeight: 'bold'}}>+16 6 787 168</h6></a>
                            {/*<h5 style={{color: 'white'}}><a style={{color: 'white', underline: 'true'}}href="https://adaateliershop.pl/">Ada Atelier</a></h5>*/}
                            {/*<h5 style={{color: 'white'}}><a style={{color: 'white', underline: 'true'}}href="http://www.lecznica-ada.pl//">Lecznica Ada</a></h5>*/}
                        </div>) :
                        (<div>
                            <h4 style={{color: 'white', fontWeight: 'bold'}}>OŚRODEK REHABILITACJI ZWIERZĄT CHRONIONYCH</h4>
                            <h5 style={{color: 'white', fontWeight: 'bold'}}>UL. ZAMOYSKIEGO 15</h5>
                            <h5 style={{color: 'white', fontWeight: 'bold'}}>37-700 PRZEMYŚL</h5>
                            <h5 style={{color: 'white', fontWeight: 'bold'}}>osrodek.rehabilitacji@gmail.com</h5>
                            <a href="tel:+166787168"><h5 style={{color: 'white', fontWeight: 'bold'}}>+16 6 787 168</h5></a>
                            {/*<h5 style={{color: 'white'}}><a style={{color: 'white', underline: 'true'}}href="https://adaateliershop.pl/">Ada Atelier</a></h5>*/}
                            {/*<h5 style={{color: 'white'}}><a style={{color: 'white', underline: 'true'}}href="http://www.lecznica-ada.pl//">Lecznica Ada</a></h5>*/}
                        </div>)

                    }
                </Card.Body>
            </Card.ImgOverlay>
        </Card>

    );
}

export default class Projects extends Component {
    render() {
        let {appData} = this.props;
        const rowStyle = {margin: '3vw 5vw 5vw 3vw'};
        return (
            <Container style={{padding: 0, marginTop: '-1.2rem'}} fluid>
                <OsrwNav appData={appData} initColor="#000000BF"/>
                <Row style={{marginTop: appData.isMobile ? '20vh': '0vh'}}/>
                <ContactCard appData={appData}/>
                <Row style={rowStyle}>
                    {!appData.isMobile &&
                    <Col xs={4} sm={4}>
                    </Col>}
                    <Col xs={appData.isMobile ? 12 : 4} sm={4}>
                        <GibButtons/>
                    </Col>
                    {!appData.isMobile &&
                    <Col xs={4} sm={4}>
                    </Col>}
                </Row>
                <Footer/>
            </Container>
        )
    }
}
